import { atom } from 'recoil';

export const restrictionTypes = atom({
  key: 'restrictionTypes',
  default: [] as string[],
});
